export const NAVIGATION_MENU_WIDTH = 274;

export const WARP_MERCHANT_STORAGE_KEY = 'warp-merchant';

export const BETTER_TEST_MARKET_TENANT_ID = 'aec8b9d3-b09e-4309-9cb9-fbb6515b33ae';
export const DASHMART_TENANT_ID = 'c9d0267f-5f67-45af-9716-2c6ac14bdaf1';
export const DASHMART_TEST_TENANT_ID = 'f61f5f8c-8c29-4734-a1e8-9c3eff7f7942';
export const DOORDASH_DMAAS_TENANT_ID = 'b3d0aaca-15bf-4516-8c4f-82fd4baedf7e';
export const HUIPPUKIVA_TENANT_ID = 'f9b60e8c-6567-488f-9dc3-a79458927d83';
export const WOLT_GLOBAL_TENANT_ID = '27a618ed-0625-4dbf-83c8-6faf7bf82a60';
export const WOLT_MARKET_TENANT_ID = '615b5598-a2cb-4319-936e-097f3bce7cc2';
export const CI_TEST_TENANT_ID = 'bffee829-8001-424b-ad41-77e0c3a6f812';

// Deliveroo tenant IDs
export const DELIVEROO_TENANT_ID_DEV = 'f8197dec-d23b-412c-a269-71d49106b5e7';
export const DELIVEROO_TENANT_ID_PROD = '506965c7-4aea-4cf9-b5f4-12a52648d417';
export const DELIVEROO_TENANT_ID_PROD_TEST = 'fdd5fafa-e772-4f58-99d0-006cec0f2f55';

export const DELIVEROO_TENANT_ID_SET = new Set([
  DELIVEROO_TENANT_ID_DEV,
  DELIVEROO_TENANT_ID_PROD,
  DELIVEROO_TENANT_ID_PROD_TEST,
]);
